import type React from "react";

interface QuestionTitleProps {
  children: React.ReactNode;
}

export function QuestionTitle({ children }: QuestionTitleProps) {
  return (
    <h2 className="mb-6 font-semibold text-2xl text-foreground leading-snug">
      {children}
    </h2>
  );
}
